<template>
  <picture>
    <source
      ref="webpSource"
      :srcset="webpSrcset"
      type="image/webp"
      :sizes="sizes"
    >
    <source
      ref="jpegSource"
      :srcset="jpegSrcset"
      type="image/jpeg"
      :sizes="sizes"
    >

    <img
      :fetchpriority="lazyLoad ? 'low' : 'high'"
      :src="src"
      :class="cssClass"
      :width="width"
      :height="height"
      :alt="alt"
      :loading="lazyLoad ? 'lazy' : null"
      @error="replaceByDefault"
      @load="loaded = true"
    >
  </picture>
  <div
    v-if="loaded === false && placeholder"
    class="img-placeholder w-100 zindex-2"
    :class="[placeholderClass]"
    :style="{ 'padding-bottom': `${placeholderHeight}%` }"
  />
</template>

<script setup>
import { computed, ref } from 'vue'

import defaultImg from '@/assets/images/default-image.png'
import { getAllImageSizeByFormat } from '@/mixins/utils'

const props = defineProps({
  alt: {
    type: String,
    default: '',
  },

  imgClass: {
    type: String,
    default: 'embed-responsive-item image-cover',
  },

  height: {
    type: String,
    default: 'auto',
  },

  width: {
    type: String,
    default: 'auto',
  },

  productImageData: {
    type: Object,
    default: undefined,
  },

  sizes: {
    type: String,
    default: '(min-width: 600px) 25vw, (min-width: 500px) 50vw, 100vw',
  },

  lazyLoad: {
    type: Boolean,
    default: true,
  },

  placeholder: {
    type: Boolean,
    default: false,
  },
  placeholderClass: {
    type: String,
    default: '',
  },
  placeholderHeight: {
    type: String,
    default: '0',
  },
})

const loaded = ref(false)
const src = computed(() => getAllImageSizeByFormat(props.productImageData, 'jpeg').llg)

const webpSource = ref()
const jpegSource = ref()

const replaceByDefault = () => {
  if (webpSource.value && jpegSource.value) {
    webpSource.value.srcset = defaultImg;
    jpegSource.value.srcset = defaultImg;
  }
}

const getSrcset = (format) => {
  return Object.values(props.productImageData)
    .map((image) => {
      const formats = image.formats[`image/${format}`]
      return `${formats} ${image.width}w`
    })
    .join(', \n')
}

const webpSrcset = computed(() => getSrcset('webp'))
const jpegSrcset = computed(() => getSrcset('jpeg'))

const cssClass = computed(() => {
  return props.imgClass
})
</script>

<style lang="scss">
.img-placeholder {
  background-color: rgba(255,255,255,.5);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-radius: 2em;
}
</style>
